// @flow

import { backendAxios } from './axios-config';
import isEmpty from 'lodash/isEmpty';
import CustomError from '../utils/error';

const { REACT_APP_WB_BACKEND_URL } = process.env;

const getUserPolicies = async (id: string, username: string) => {
  const { WB_API_CACHE = {} } = window;

  if (isEmpty(REACT_APP_WB_BACKEND_URL)) throw new CustomError('Empty URL');

  const cachedData = WB_API_CACHE[`_user_policies_${id}`];

  if (id && cachedData && typeof cachedData === 'object') {
    return { data: cachedData };
  }

  const response = await backendAxios.get('/policies', {
    params: {
      userId: id,
      username,
    },
  });

  if (id) {
    window.WB_API_CACHE[`_user_policies_${id}`] = response.data;
  }

  return response;
};

export default getUserPolicies;
